<template>
	<div>
		<div class="flex wrap alcenter">
			<div v-for="(item, index) in pics" :key="index" class="show-upload-list-item">
				<img :src="item" />
				<div class="show-action">
					<div class="flex space alcenter">
						<a-icon @click="showDiv(index)" type="eye" />
						<a-icon @click="delPic(index)" style="margin-left: 15px" type="delete" />
					</div>
				</div>
			</div>
			<!--原有的不太好用-->
			<div v-if="value.length < num">
				<a-upload name="file" listType="picture-card"  :show-upload-list="false"
					:customRequest="uploadImg" :beforeUpload="beforeUpload">
					<div>
						<a-icon :type="loading ? 'loading' : 'plus'" />
					</div>
				</a-upload>
			</div>
		</div>

		<a-modal :title="null" v-model="showDivAlert" :footer="null" :closable="false" @cancel="showDivAlert=false">
			<img style="width: 100%" :src="pics[selectIndex]" />
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: Array,
				default: function() {
					return new Array();
				},
			},
			num: {
				type: Number,
				default: 10,
			},
		},
		computed: {
			pics() {
				return this.value;
			},
		},
		data() {
			return {
				loading: false,
				showDivAlert: false,
				selectIndex: 0,
			};
		},
		methods: {
			showDiv(index) {
				this.selectIndex = index;
				this.showDivAlert = true;
			},
			delPic(index) {
				this.$confirm({
					title: "确定要删除吗？",
					content: "删除该图片",
					okText: "确定",
					okType: "danger",
					cancelText: this.$t('common.cancel'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						let pics = JSON.parse(JSON.stringify(this.value));
						pics.splice(index, 1);
						this.$emit("input", pics);
					},
					onCancel: () => {
						console.log("Cancel");
					},
				});
			},
			uploadImg(e) {
				let file = e.file;
				this.loading = true;
				this.$http.upload(file).then((res) => {
						let value = JSON.parse(JSON.stringify(this.value));
						value.push(res.fullurl);
						this.$emit("input", value);
						this.loading = false;
					})
					.catch((res) => {
						console.log("---res",res);
						this.$message.error("上传图片出错了");
						this.loading = false;
					});
			},

			beforeUpload(file) {
				const isImg =
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/gif";
				if (!isImg) {
					this.$message.error("只能允许上传图片");
				}
				const isLt2M = file.size / 1024 / 1024 < 20;
				if (!isLt2M) {
					this.$message.error("图片最大为20M");
				}
				if (this.value.length >= this.num) {
					this.$message.error("你上传的图片已达到" + this.num + "张");
				}
				return isImg && isLt2M;
			},

			formatFloat(f, digit) {
				let m = Math.pow(10, digit);
				let num = Math.round(f * m) / m;
				return num;
			},
		},
	};
</script>

<style>
	.show-upload-list-item {
		padding: 8px;
		margin-right: 8px;
		margin-bottom: 8px;
		text-align: center;
		vertical-align: top;
		background-color: #fafafa;
		border: 1px dashed #d9d9d9;
		border-radius: 4px;
		cursor: pointer;
		-webkit-transition: border-color 0.3s ease;
		transition: border-color 0.3s ease;
		overflow: hidden;
		width: 80px;
		height: 80px;
		position: relative;
	}

	.show-upload-list-item .show-action {
		position: absolute;
		width: 80px;
		height: 80px;
		left: 0;
		top: 0;
		background: rgba(0, 0, 0, 0.3);
		opacity: 0;
		transition: opacity 0.3s;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #ffffff;
		font-size: 24px;
	}

	.show-upload-list-item:hover .show-action {
		opacity: 1;
	}

	.show-upload-list-item:hover {
		border-color: #4772ff;
	}

	.show-upload-list-item img {
		object-fit: cover;
		width: 65px;
		height: 65px;
	}

	.upload-list>.ant-upload {
		width: 80px;
		height: 80px;
		overflow: hidden;
	}

	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>